/*
		ajax.js,
			Ajax functions. Support for asynchronous get and post requests (uses callbacks).
 */

var Browser = require('./browser.js');

var JsonP = module.exports = {

	request: function(callback) {
		var http_request = false;

		if(! Browser.isIE) { // Mozilla, Safari,IE7,...
			http_request = new XMLHttpRequest();
		}
		else if(window.ActiveXObject) { // IE6
			try {
				http_request = new ActiveXObject("Msxml2.XMLHTTP");
			}
			catch (e) {
				try {
					http_request = new ActiveXObject("Microsoft.XMLHTTP");
				}
				catch (e) {}
			}
		}

		if(http_request) {
			http_request.onreadystatechange = function() {
				if(http_request.readyState == 4) {
					var data, stat, stattxt;
					try {
						data = http_request.responseText;
						stat = http_request.status;
						stattxt = http_request.statusText;
						xml = http_request.responseXML;
					}
					catch(e) {
						/* network error */
						data = null;
						stat = 0;
						stattxt = 'Network error';
						xml = null;
					}
					callback(data, stat, stattxt, xml);
				}
			};
		}

		return http_request;
	},

	makecallback: function(callback){
		return function(){callback('', 500, '', '')};
	},

	get: function(url, callback) {
		var script = document.createElement("script");
		script.setAttribute("type", "text/javascript");

		script.onerror = this.makecallback(callback);

		script.setAttribute("src", url);

		document.body.appendChild(script);

		setTimeout(function(){
			document.body.removeChild(script);
		}, 2000);
		return true;
	},

	encode: function(params) {
		var data = '';
		for(var i = 0; i < params.length; i++) {
			if(i != 0)
				data += "&";
			data += params[i][0] + "=" + encodeURIComponent(params[i][1]);
		}
		return data;
	}
};

